import React from 'react';
import '../framework/SpreadTable/spread-table.css';
import AcquireWebComponent from '../framework/MaterialUI/index'
import ArrowDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import ArrowUp from 'material-ui/svg-icons/navigation/arrow-drop-up';
import Checkbox from 'material-ui/Checkbox';
import isEqual from 'lodash/isEqual';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import moment from "moment/moment";
import reverse from 'lodash/reverse';

const arrowStyles = {
  position: 'absolute',
  right: 0,
  top: '7px'
}

const altArrowStyles = {
  position: 'absolute',
  right: 0,
  top: '0px'
}

class ChannelCampaignsTable extends AcquireWebComponent {
  constructor (props) {
    super(props);
    this.state = {
      activeIndex: props.activeIndex,
      arrowActive: 'down',
			sltIds:[],
			bodyData:props.bodyDataArr
    }
  }

  componentDidMount () {

  }

  componentWillReceiveProps(nextProps) {
		if (!isEqual(nextProps.bodyDataArr.slice().sort(), this.props.bodyDataArr.slice().sort())) {
			this.setState({
				bodyData: nextProps.bodyDataArr
			})
		}
	}

  handleClick (label, index) {
    if ((label === "Select") || (label === "")){
      return 
    }
    let sortDesc = false
    this.setState({
      activeIndex: index
    });
    if (+index === this.state.activeIndex) {
      if (this.state.arrowActive === 'down') {
        this.setState({
          arrowActive: 'up'
        })
      } else {
        this.setState({
          arrowActive: 'down'
        })
      }
    } else {
      this.setState({
        arrowActive: 'down'
      })
    }

    let sortField = ""
    switch(label){
      case "Campaign Name":
        sortField = "name";
        break;
      case "Campaign ID":
        sortField = "campaignId";
        break;
      case "Campaign Start Date":
        sortField = "startDate";
        break;
      case "Campaign End Date":
        sortField = "endDate";
        break;
      case "Status":
        sortField = "status";
        break;
      default:
        sortField = "name";
        break;
    }

    const list = sortDesc ? reverse(sortBy(this.state.bodyData, (data)=>{
      return data[sortField];
    })) : sortBy(this.state.bodyData, (data)=>{
      return data[sortField];
    })

    this.setState({
      bodyData: list
    })
  }

	updateCheck(id) {
		map(this.state.bodyData, (data)=>{
			if (parseInt(data.id, 10) === parseInt(id, 10)) {
				data.select = !data.select;
			}
		})

		this.props.selectCampaignIds(id)
		this.forceUpdate();
	}

  removeCampaign(cid) {
		this.props.removeCampaignId(cid)
    this.forceUpdate();
  }

  render () {
    return (
      <div className="spread-table">
        <table>
          <thead>
          <tr>
            {this.props.tableHeaderArr.map((item, index) => {
              let widthStyle = '';
              switch (index) {
                case 0:
                  widthStyle = this.props.tableHeaderWidthStyle[0];
                  break;
                case 1:
                  widthStyle = this.props.tableHeaderWidthStyle[1];
                  break;
                case 2:
                  widthStyle = this.props.tableHeaderWidthStyle[2];
                  break;
                case 3:
                  widthStyle = this.props.tableHeaderWidthStyle[3];
                  break;
                case 4:
                  widthStyle = this.props.tableHeaderWidthStyle[4];
                  break;
                case 5:
                  widthStyle = this.props.tableHeaderWidthStyle[5];
                  break;
                case 6:
                  widthStyle = this.props.tableHeaderWidthStyle[6];
                  break;
                default:
                  widthStyle = '';
                  break;
              }
              return (
                <th key={item.value}
                    className={this.state.activeIndex === index ? 'active' : ''}
                    onClick={(e) => {this.props.sortable ? this.handleClick(item.label, index) : e.preventDefault()}}
                    style={{width: widthStyle, whiteSpace: 'pre-wrap', paddingLeft: index === 0 ? "20px" : '10px'}}
                >
                  <span className="text">{item.label}</span>
                  {
                    (
                      this.state.activeIndex === index && this.props.sortable &&
                      this.state.arrowActive === 'down' 
                    ) && (
                      <ArrowDown
                        style={this.props.narrowHeader ? {...altArrowStyles} : {
                          ...arrowStyles
                        }}
                      />
                    )
                  }
                  {
                    (
                      this.state.activeIndex === index && this.props.sortable &&
                      this.state.arrowActive === 'up' 
                    ) && (
                      <ArrowUp
                        style={this.props.narrowHeader ? {...altArrowStyles}:{
                          ...arrowStyles
                        }}
                      />
                    )
                  }
                </th>
              )
            })}
          </tr>
          </thead>
          <tbody>
          {
            this.state.bodyData.map((item, index)=>{
              return (
                <tr key={index}>
									{this.props.showSelectBox && <td>
                    <Checkbox iconStyle={{fill:"#47A1AB"}} 
                      checked={item.select} onCheck={this.updateCheck.bind(this, item.id)} /></td>
                  }
                  <td style={{paddingLeft:'20px'}}>{item.name}</td>
									<td>{item.campaignId}</td>
									<td>{moment(item.startDate).format("MM/DD/YY")}</td>
									<td>{item.endDate ? moment(item.endDate).format("MM/DD/YY") : ""}</td>
									<td>{item.status}</td>
                  <td>
                    {this.props.showDelBtn &&
                      <a onClick={(e)=>{e.preventDefault();this.removeCampaign(item.id)}}><i className="icon-cancel-circle2" style={{color:"red"}}></i></a>
                    }
                  </td>
                </tr>
              )
						})
					}
          </tbody>

        </table>
      </div>
    )
  }
}

ChannelCampaignsTable.defaultProps = {
  tableHeaderWidthStyle: ['22%', '22%', '10%', '20%'],
  bodyDataArr: [],
  bodyDataKey: [],
  activeIndex: 0,
  renderCols: {
    addCol: '',
    cols: []
  },
  showSelectBox:true,
  showDelBtn:false,
  narrowHeader: false,
  sortable: false
}

export default ChannelCampaignsTable;



// WEBPACK FOOTER //
// ./src/components/Campaigns/ChannelCampaignsTable.jsx